export default __webpack_public_path__ + "static/herbPolski-ea96d6b0eb8a4b936fe89c55960ae37e.svg";